module.exports = __webpack_public_path__ + "img/37-859535.png";